var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import Neighborhoods from '@/modules/search/components/filterPanels/LocalizationPanel/Neighborhoods.vue';
import { connect } from '@/overmind';
let NeighborhoodsContainer = class NeighborhoodsContainer extends Vue {
    setNeighborhoodsName({ value, type }) {
        // @ts-ignore TS2349: property inexistent
        this.actions.setSelectedFilterNeighborhood({ value, type });
        // @ts-ignore TS2349: property inexistent
        this.actionsSearch.searches.buildPotentialResults();
    }
};
__decorate([
    Prop({ default: () => { } })
], NeighborhoodsContainer.prototype, "filter", void 0);
NeighborhoodsContainer = __decorate([
    Component(connect(({ state: { filters: state }, actions }) => ({
        actions: actions.filters,
        actionsSearch: actions.search,
        selectedFilterNeighborhoods: state.selectedFilterNeighborhoods,
    }), {
        components: {
            Neighborhoods,
        },
    }))
], NeighborhoodsContainer);
export default NeighborhoodsContainer;
